/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
import { AxiosResponse } from 'axios';
import { call, delay, put, takeLatest } from 'redux-saga/effects';

import apiNew from '../../api/api';
import { errorHandling } from '../../api/errorHandling';
import {
 reportsGenerateFailure,
 reportsGenerateFinish,
 reportsGenerateStart,
 reportsGenerateSuccess,
} from './reportsSlice';

function* reportsGenerateSaga(props: any) {
 const { type, ...rest } = props.payload;
 try {
  const response: AxiosResponse<any> = yield call(
   apiNew.post,
   `/Reports/v1/generate${type === 'Word' ? 'docx' : 'pdf'}`,
   rest,
  );

  yield put(
   reportsGenerateSuccess({
    report: {
     name: response.data.Name,
     type: response.data.Type,
     file: response.data.File,
     extension: response.data.Extension,
    },
    message: 'Report generated successfully',
    type: 'success',
   }),
  );
  yield delay(0);
  yield put(reportsGenerateFinish({}));
 } catch (error) {
  yield* errorHandling(error, reportsGenerateFailure);
 }
}

export function* watchReportsSaga() {
 yield takeLatest(reportsGenerateStart.type, reportsGenerateSaga);
}
